<template>
  <v-btn
    :block="block"
    :type="type"
    :loading="loading"
    :height="height"
    :color="color"
    :large="large"
    :x-large="xLarge"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <v-icon v-if="iconOrientation === 'left'" left> {{ icon }} </v-icon>
    {{ text }}
    <v-icon v-if="iconOrientation === 'right'" right> {{ icon }} </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'BasicButton',
  props: {
    loading: { type: Boolean, default: false },
    type: { type: String, default: 'button' },
    text: { type: String, default: '' },
    color: { type: String, default: '' },
    height: { type: Number, default: 36 },
    icon: { type: String, default: '' },
    iconOrientation: { type: String, default: '' },
    block: { type: Boolean, default: true },
    large: { type: Boolean, default: false },
    xLarge: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style></style>
